import { Component } from '@angular/core';
import { TestingService } from '../../../models/testing/testingService';
import { Test } from '../../../models/testing/test';
import { TestRun } from '../../../models/testing/testRun';

@Component({
  selector: 'app-testing',
  templateUrl: './testing.component.html',
  standalone: false,
})
export class TestingComponent {
  testRuns: TestRun[] = [];
  tests: Test[] = [];
  loading: boolean = false;

  constructor(private api: TestingService) {
    this.getTestRuns();
  }

  getTestRuns(): void {
    this.loading = true;
    this.api
      .getTestRuns()
      .then((testRuns: TestRun[]) => {
        this.testRuns = testRuns;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getTests(testRunId: string): void {
    this.api.getTests(testRunId).then((tests: Test[]) => {
      this.tests = tests;
    });
  }

  runTests(): void {
    this.loading = true;

    this.api
      .runTests()
      .then((success: boolean) => {
        this.getTestRuns();
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getTestRunBackgroundColor(successPct: number): string {
    if (successPct >= 90) return 'background-color: #44cc44; color:#ffffff;';
    else if (successPct >= 70)
      return 'background-color: #ffccaa; color:#ffffff;';
    else return 'background-color: #cc4444; color:#ffffff;';
  }

  getTestBackgroundColor(success: boolean): string {
    return success
      ? 'background-color: #44cc44; color:#ffffff;'
      : 'background-color: #cc4444; color:#ffffff;';
  }

  formatTime(timeStr: string): string {
    const date = new Date(timeStr);
    return date.toLocaleTimeString();
  }

  formatElapsedTime(timeStr: string): string {
    // Parse the time string into a Date
    const date = new Date(timeStr);

    // Get hours, minutes, seconds, and milliseconds (UTC to avoid timezone offset)
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const milliseconds = date.getUTCMilliseconds();

    // Format with zero-padding
    const hh = hours.toString().padStart(2, '0');
    const mm = minutes.toString().padStart(2, '0');
    const ss = seconds.toString().padStart(2, '0');
    const ms = milliseconds.toString().padStart(3, '0');

    return `${hh}:${mm}:${ss}.${ms}`;
  }
}
